export default __webpack_public_path__ + "static/media/que-hace-klouser-por-ti.86a368a4.png";